/* Sticky bottom panel for the PDP (snippets/mp-sticky-bar.liquid) */
(function() {
  /*
   * Only write to the DOM when a value actually changes. Other scripts on the page (GoKwik) observe DOM
   * changes and re-apply attributes on the Buy Now button, which our own observers watch. Redundant writes
   * here would feed that loop.
   */
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setDisabled(el, value) {
    if (el && el.disabled !== value) el.disabled = value;
  }

  function setTabIndex(el, value) {
    if (el && el.tabIndex !== value) el.tabIndex = value;
  }

  function setSrc(el, src) {
    if (el && el.getAttribute('src') !== src) el.src = src;
  }

  /* Spinner on the sticky panel button the shopper clicked (assets/cta-loader.js) */
  function loadAdd(btn) {
    if (window.CtaLoader) window.CtaLoader.startAdd(btn);
  }

  function loadBuy(btn) {
    if (window.CtaLoader) window.CtaLoader.startBuy(btn);
  }

  function init(panel) {
    if (panel.dataset.mpStickyReady) return;

    const root = panel.closest('.mp');
    const addBtn = root && root.querySelector('.mp__add');
    if (!addBtn) return;
    panel.dataset.mpStickyReady = 'true';

    const stickyBtn = panel.querySelector('[data-mp-sticky-btn]');
    const stickyBuy = panel.querySelector('[data-mp-sticky-buy]');
    const buyBtn = root.querySelector('#gokwik-buy-now');
    const stickyImg = panel.querySelector('[data-mp-sticky-img]');
    const stickyPrice = panel.querySelector('[data-mp-sticky-price]');
    const stickyCompare = panel.querySelector('[data-mp-sticky-compare]');
    const stickyBadge = panel.querySelector('[data-mp-sticky-badge]');
    const badge = root.querySelector('[data-mp-badge]');
    const priceNow = root.querySelector('[data-mp-price-now]');
    const compare = root.querySelector('[data-mp-compare]');
    const mainAsset = root.querySelector('[data-mp-main-asset]');

    /* Quick view popup: only for products that show a variant picker on the page */
    const qv = root.querySelector('[data-mp-qv]');
    const optionGroups = Array.from(root.querySelectorAll('.mp__variants .mp__variantGroup'));
    const configurable = !!qv && optionGroups.length > 0;
    const qvDialog = configurable ? qv.querySelector('.mp__qvDialog') : null;
    const qvOptions = configurable ? qv.querySelector('[data-mp-qv-options]') : null;
    const qvAdd = configurable ? qv.querySelector('[data-mp-qv-add]') : null;
    const qvBuy = configurable ? qv.querySelector('[data-mp-qv-buy]') : null;
    const qvImg = configurable ? qv.querySelector('[data-mp-qv-img]') : null;
    const qvPrice = configurable ? qv.querySelector('[data-mp-qv-price]') : null;
    const qvCompare = configurable ? qv.querySelector('[data-mp-qv-compare]') : null;
    const qvBadge = configurable ? qv.querySelector('[data-mp-qv-badge]') : null;
    let qvOpener = null;
    let qvOptionBtns = [];

    function show(visible) {
      panel.classList.toggle('is-visible', visible);
      panel.setAttribute('aria-hidden', visible ? 'false' : 'true');
      setTabIndex(stickyBtn, visible ? 0 : -1);
      setTabIndex(stickyBuy, visible ? 0 : -1);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        show(!entries[0].isIntersecting);
      }).observe(addBtn);
    }

    /* Quick view popup */
    function buildQvOptions() {
      qvOptions.innerHTML = '';
      qvOptionBtns = [];

      optionGroups.forEach(function(group) {
        const label = group.querySelector('.mp__variantLabel');
        const selected = group.querySelector('.mp__variantSelected');

        const wrap = document.createElement('div');
        wrap.className = 'mp__qvGroup';

        const head = document.createElement('div');
        head.className = 'mp__qvLabel';
        head.appendChild(document.createTextNode(label ? label.textContent.trim() + ' ' : ''));
        const selectedEl = document.createElement('span');
        head.appendChild(selectedEl);
        wrap.appendChild(head);

        const values = document.createElement('div');
        values.className = 'mp__qvValues';

        Array.from(group.querySelectorAll('[data-mp-option-btn]')).forEach(function(real) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mp__qvBtn';
          /* Use the option value, not textContent, which also includes the hot deal tag span inside the PDP button */
          btn.textContent = real.dataset.optionValue || real.textContent.trim();
          /* Show the same hot deal tag as the PDP button */
          const tag = real.querySelector('.pdp-hot-deal-tag');
          if (tag) btn.appendChild(tag.cloneNode(true));
          btn.addEventListener('click', function() {
            /* The PDP's own handler updates the variant, price, image and stock */
            real.click();
            syncQv();
          });
          values.appendChild(btn);
          qvOptionBtns.push({ btn: btn, real: real, selectedEl: selectedEl, selected: selected });
        });

        wrap.appendChild(values);
        qvOptions.appendChild(wrap);
      });
    }

    function syncQv() {
      qvOptionBtns.forEach(function(item) {
        item.btn.classList.toggle('is-active', item.real.classList.contains('is-active'));
        setDisabled(item.btn, item.real.disabled);
        if (item.selected) setText(item.selectedEl, item.selected.textContent.trim());
      });
      setDisabled(qvAdd, addBtn.disabled);
      setText(qvAdd, addBtn.textContent.trim() || qvAdd.textContent);
    }

    function openQv(opener) {
      qvOpener = opener;
      buildQvOptions();
      syncPrice();
      syncImage();
      syncBuyButton();
      syncQv();

      /* Show only the action that opened the popup: Buy Now opens it with Buy Now, Add to Cart with Add to Cart */
      const buyMode = !!stickyBuy && opener === stickyBuy;
      qvAdd.hidden = buyMode;
      if (qvBuy) qvBuy.hidden = !buyMode;

      qv.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      qvDialog.focus();
    }

    function closeQv() {
      if (qv.hidden) return;
      qv.hidden = true;
      document.documentElement.style.overflow = '';
      if (qvOpener) qvOpener.focus();
    }

    function onQvKeydown(event) {
      if (qv.hidden) return;
      if (event.key === 'Escape') {
        closeQv();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = Array.from(qvDialog.querySelectorAll('button:not(:disabled)'))
        .filter(function(el) { return !el.hidden; });
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === qvDialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    if (configurable) {
      qv.querySelectorAll('[data-mp-qv-close]').forEach(function(el) {
        el.addEventListener('click', closeQv);
      });
      document.addEventListener('keydown', onQvKeydown);

      qvAdd.addEventListener('click', function() {
        closeQv();
        loadAdd(stickyBtn);
        addBtn.click();
      });
      if (qvBuy) {
        qvBuy.addEventListener('click', function() {
          closeQv();
          loadBuy(stickyBuy);
          if (buyBtn) buyBtn.click();
        });
      }
    }

    /* Products with options open the popup; others add straight to the cart */
    stickyBtn.addEventListener('click', function() {
      if (configurable) {
        openQv(stickyBtn);
      } else {
        loadAdd(stickyBtn);
        addBtn.click();
      }
    });

    /* Buy Now runs GoKwik's own handler by clicking the original button */
    if (stickyBuy) {
      stickyBuy.addEventListener('click', function() {
        if (configurable) {
          openQv(stickyBuy);
        } else if (buyBtn) {
          loadBuy(stickyBuy);
          buyBtn.click();
        }
      });
    }

    function syncPrice() {
      if (priceNow) {
        const now = priceNow.textContent.trim();
        setText(stickyPrice, now);
        setText(qvPrice, now);
      }
      if (compare) {
        const text = compare.textContent.trim();
        const hide = !text || compare.classList.contains('hidden');
        if (stickyCompare) {
          setText(stickyCompare, text);
          stickyCompare.classList.toggle('hidden', hide);
        }
        if (qvCompare) {
          setText(qvCompare, text);
          qvCompare.classList.toggle('hidden', hide);
        }
      }
      syncBadge();
    }

    function syncBadge() {
      if (!badge) return;
      const hide = badge.classList.contains('hidden') || !badge.textContent.trim();
      [stickyBadge, qvBadge].forEach((el) => {
        if (!el) return;
        el.innerHTML = badge.innerHTML;
        el.classList.toggle('hidden', hide);
      });
    }

    function syncButton() {
      /* Keep the sticky button clickable on products with options so the popup can change the variant */
      setDisabled(stickyBtn, configurable ? false : addBtn.disabled);
      setText(stickyBtn, addBtn.textContent.trim());
      if (configurable && !qv.hidden) syncQv();
    }

    function syncBuyButton() {
      if (!stickyBuy) return;
      if (!buyBtn) {
        stickyBuy.classList.add('hidden');
        if (qvBuy) qvBuy.classList.add('hidden');
        return;
      }
      const hidden = getComputedStyle(buyBtn).display === 'none';
      const disabled = buyBtn.disabled || addBtn.disabled;
      stickyBuy.classList.toggle('hidden', hidden);
      setDisabled(stickyBuy, configurable ? false : disabled);
      if (qvBuy) {
        qvBuy.classList.toggle('hidden', hidden);
        setDisabled(qvBuy, disabled);
      }
      const label = Array.from(buyBtn.childNodes)
        .filter(function(n) { return n.nodeType === 3; })
        .map(function(n) { return n.textContent; })
        .join('')
        .trim();
      if (label) {
        setText(stickyBuy, label);
        setText(qvBuy, label);
      }
    }

    function syncImage() {
      const img = mainAsset && mainAsset.querySelector('img.mp__mainImg');
      if (!img) return;
      if (stickyImg) {
        setSrc(stickyImg, img.src.replace(/([?&]width=)\d+/, '$1160'));
        stickyImg.alt = img.alt || stickyImg.alt;
      }
      if (qvImg) {
        setSrc(qvImg, img.src.replace(/([?&]width=)\d+/, '$1320'));
        qvImg.alt = img.alt || qvImg.alt;
      }
    }

    const priceWrap = root.querySelector('.mp__priceRow');
    if (priceWrap) {
      new MutationObserver(syncPrice).observe(priceWrap, {
        childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
    }
    new MutationObserver(syncButton).observe(addBtn, {
      childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled']
    });
    if (mainAsset) {
      new MutationObserver(syncImage).observe(mainAsset, { childList: true, subtree: true });
    }

    if (buyBtn) {
      new MutationObserver(syncBuyButton).observe(buyBtn, {
        childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'style']
      });
    }
    new MutationObserver(syncBuyButton).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });

    syncPrice();
    syncButton();
    syncBuyButton();
  }

  function initAll() {
    document.querySelectorAll('[data-mp-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
